export { t, tOpt, translateOptional, translate, setLocale } from './translate';
